/* eslint-disable operator-linebreak */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import { DocumentsCategory, IPage } from 'src/interfaces';

import documentsService from 'src/services/documents.service';
import { IDocument } from 'src/interfaces/document';

import { useQuery } from '@tanstack/react-query';
import { Loader } from 'pg-ui-library';
import DocumentDropArea from './document-drop-area';
import {
  Container,
  DataPrivacyContainer,
  Divider,
  DocumentsContainer,
  DocumentsContainerUpload,
  HeaderContainer,
  NavTextLink,
  OthersDocumentsContainer,
} from './styles';

const DocumentsPage: React.FC<IPage> = () => {
  const [employeeDocuments, setEmployeeDocuments] = useState<{
    [key: string]: IDocument | IDocument[];
  }>({});

  const { isLoading, data } = useQuery({
    queryKey: ['documents'],
    queryFn: documentsService.getDocuments,
    enabled: true,
  });

  useEffect(() => {
    if (data) {
      const mappedDocs: { [key: string]: IDocument | IDocument[] } = {};
      mappedDocs[DocumentsCategory.OTHERS] = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].documentCategory === DocumentsCategory.OTHERS) {
          mappedDocs[data[i].documentCategory] = (mappedDocs[data[i].documentCategory] as IDocument[]).concat(data[i]);
        } else {
          mappedDocs[data[i].documentCategory] = data[i];
        }
      }
      setEmployeeDocuments(mappedDocs);
    }
  }, [data]);

  return (
    <Container>
      <HeaderContainer>
        <h2>Documents Upload</h2>
      </HeaderContainer>
      <DataPrivacyContainer>
        <NavTextLink href="https://prideglobal.com/privacy-policy/" target="_blank">
          <h4>DATA PRIVACY</h4>
        </NavTextLink>
      </DataPrivacyContainer>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          <DocumentsContainer>
            <DocumentsContainerUpload>
              <span>Form I-9</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.FORM_I_9}
                employeeDocument={(employeeDocuments[DocumentsCategory.FORM_I_9] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>W4 Form</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.W4_FORM}
                employeeDocument={(employeeDocuments[DocumentsCategory.W4_FORM] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Employment verification</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.EMPLOYMENT_VERIFICATION}
                employeeDocument={(employeeDocuments[DocumentsCategory.EMPLOYMENT_VERIFICATION] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Social Security Number</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.SOCIAL_SECURITY_NUMBER}
                employeeDocument={(employeeDocuments[DocumentsCategory.SOCIAL_SECURITY_NUMBER] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Driver´s License</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.DRIVERS_LICENSE}
                employeeDocument={(employeeDocuments[DocumentsCategory.DRIVERS_LICENSE] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Passport</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.PASSPORT}
                employeeDocument={(employeeDocuments[DocumentsCategory.PASSPORT] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Visa Documents</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.VISA_DOCUMENTS}
                employeeDocument={(employeeDocuments[DocumentsCategory.VISA_DOCUMENTS] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Direct Deposit Form</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.DIRECT_DEPOSIT_FORM}
                employeeDocument={(employeeDocuments[DocumentsCategory.DIRECT_DEPOSIT_FORM] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Voided Check/Bank Letter</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.VOIDED_CHECK_BANK_LETTER}
                employeeDocument={(employeeDocuments[DocumentsCategory.VOIDED_CHECK_BANK_LETTER] as IDocument) || null}
              />
            </DocumentsContainerUpload>
            <DocumentsContainerUpload>
              <span>Vaccination Cards</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.VACCINATION_CARD}
                employeeDocument={(employeeDocuments[DocumentsCategory.VACCINATION_CARD] as IDocument) || null}
              />
            </DocumentsContainerUpload>
          </DocumentsContainer>
          <Divider />
          <OthersDocumentsContainer>
            {employeeDocuments[DocumentsCategory.OTHERS] &&
              (employeeDocuments[DocumentsCategory.OTHERS] as IDocument[]).map(doc => (
                <DocumentsContainerUpload key={doc.id}>
                  <span>Others</span>
                  <DocumentDropArea documentCategory={DocumentsCategory.OTHERS} employeeDocument={doc} multipleFiles />
                </DocumentsContainerUpload>
              ))}
            <DocumentsContainerUpload>
              <span>Others</span>
              <DocumentDropArea
                documentCategory={DocumentsCategory.OTHERS}
                employeeDocument={undefined}
                multipleFiles
              />
            </DocumentsContainerUpload>
            {/**
            <DocumentsContainerUpload>
              <DocumentCommentContainer
                rows={8}
                placeholder="Comments..."
              ></DocumentCommentContainer>
            </DocumentsContainerUpload>
              */}
          </OthersDocumentsContainer>
        </>
      )}
    </Container>
  );
};

export default DocumentsPage;
